import Vue from "vue";

/** v-tableSelect
 * 功能描述：el-table 拖动勾选
 * 使用范围：el-table
*/
export default {
    name: 'tableSelect',
    bind(el, binding, vnode) {
        // console.log('bind', el, binding, vnode);

        if(!vnode.componentOptions || vnode.componentOptions.tag !== 'el-table') {
            throw new Error('el-table is not bound！');
        }

        const selectObj = {
            flag: false,
            x: 0,
            y: 0
        };
        const bodyWrapper = el;
        const bodyTable = el.querySelector('.el-table__body-wrapper');
        const ref = vnode.componentInstance;

        const mousedown = function(e) {
            // console.log('mousedown', e, bodyTable.scrollTop);
            const bodyOffsetTop = el['bodyOffsetTop'];
            selectObj.flag = true;
            selectObj.x = e.clientX;
            selectObj.y = e.clientY - bodyOffsetTop + bodyTable.scrollTop;
            bindMouseMove(bodyWrapper, true);
            bindMouseUp(bodyWrapper, true);
            bindMouseLeave(bodyWrapper, true);
        };
        const mousemove = function(e) {
            // console.log('mousemove', e);
            if(!selectObj.flag) return;

            const bodyOffsetTop = el['bodyOffsetTop'];
            const bodyTable = el.querySelector('.el-table__body-wrapper');
            const max = bodyWrapper.clientHeight + bodyOffsetTop - 120;
            const min = bodyOffsetTop + 120;

            if(max < e.clientY) {
                bodyTable.scrollTop += 5;
            }else if(min > e.clientY) {
                bodyTable.scrollTop -= 5;
            }

            e.preventDefault();
            e.stopPropagation();
        };
        const mouseup = (e) => {
            // console.log('mouseup', e);
            // 1. 根据拖动距离计算选中的行
            selectObj.flag = false;
            const bodyOffsetTop = el['bodyOffsetTop'];

            const rows = el['tkRows'];
            const list = ref.data;
            if(rows.length == list.length) {
                const selectList = [];
                const y = e.clientY - bodyOffsetTop + bodyTable.scrollTop;
                const max = Math.max(selectObj.y, y);
                const min = Math.min(selectObj.y, y);

                for(let index = 0; index < rows.length; index++) {
                    const row = rows[index];
                    if(max - min < row.clientHeight) break;
                    // console.log('start', row.offsetTop);
                    // console.log('end', row.offsetTop + row.clientHeight);
                    if(row.offsetTop <= min && (row.offsetTop + row.clientHeight >= min)) {
                        selectList.push(list[index]);
                    }else if(row.offsetTop < max && (row.offsetTop + row.clientHeight > max)) {
                        selectList.push(list[index]);
                        break;
                    }else if(row.offsetTop > min && (row.offsetTop + row.clientHeight <= max)) {
                        selectList.push(list[index]);
                    }
                }
                Vue.nextTick(() => {
                    // 选中
                    if(selectList.length > 0) {
                        ref.$emit('drag-select', selectList.slice());
                    }
                });
            }


            // 2. 取消相关监听
            bindMouseMove(bodyWrapper);
            bindMouseUp(bodyWrapper);
            bindMouseLeave(bodyWrapper);
            resetSelectObj();

            e.preventDefault();
            e.stopPropagation();
        };
        const mouseleave = function(e) {
            // console.log('mouseleave', e);
            bindMouseMove(bodyWrapper);
            bindMouseUp(bodyWrapper);
            bindMouseLeave(bodyWrapper);
            resetSelectObj();

            e.preventDefault();
            e.stopPropagation();
        };

        const resetSelectObj = () => {
            selectObj.flag = false;
            selectObj.x = 0;
            selectObj.y = 0;
        };

        const bindMouseMove = (el, bind) => {
            if(bind) {
                el.addEventListener('mousemove', mousemove);
            }else {
                el.removeEventListener('mousemove', mousemove);
            }
        };
        const bindMouseUp = (el, bind) => {
            if(bind) {
                el.addEventListener('mouseup', mouseup);
            }else {
                el.removeEventListener('mouseup', mouseup);
            }
        };
        const bindMouseLeave = (el, bind) => {
            if(bind) {
                el.addEventListener('mouseleave', mouseleave);
            }else {
                el.removeEventListener('mouseleave', mouseleave);
            }
        };

        bodyWrapper.addEventListener('mousedown', mousedown);
        bodyWrapper['tkMousedown'] = mousedown;
    },
    componentUpdated(el) {
        // console.log('componentUpdated', el);
        Vue.nextTick(() => {
            const rows = el.querySelector('.el-table__body-wrapper').querySelector('.el-table__body').querySelectorAll('tbody tr');
            el['tkRows'] = rows;

            const bodyWrapper = el;
            const headerWrapper = el.querySelector('.el-table__header-wrapper');

            let bodyOffsetTop = bodyWrapper.offsetTop;
            let offsetParent = bodyWrapper.offsetParent;
            // 循环遍历出距离浏览器高度
            while(offsetParent) {
                bodyOffsetTop += offsetParent.offsetTop;
                if(offsetParent.offsetParent) {
                    offsetParent = offsetParent.offsetParent;
                }else {
                    break;
                }
            }
            bodyOffsetTop += headerWrapper.clientHeight;
            el['bodyOffsetTop'] = bodyOffsetTop;
        });
    },
    unbind(el) {
        // console.log('unbind', el);

        delete el['tkRows'];
        const bodyWrapper = el;
        const mousedown = bodyWrapper['tkMousedown'];
        bodyWrapper.removeEventListener('mousedown', mousedown);
    }
};
